/**
 * DocumentUploadButton Component
 * Button that opens the document upload modal
 */

import { Button } from '../../../../../components/Button';
import { AddIcon } from '../../../../../assets/AddIcon';

interface DocumentUploadButtonProps {
  onOpenModal: () => void;
  disabled: boolean;
}

export function DocumentUploadButton({ onOpenModal, disabled }: DocumentUploadButtonProps) {
  return (
    <Button
      variant="primary"
      onClick={onOpenModal}
      disabled={disabled}
      aria-label="Upload document"
    >
      <AddIcon />
      Add Document
    </Button>
  );
}
